import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { selectListItems } from "../../../../../../redux/tasks/selector";
import { tasks } from "../../../../../../redux/tasks/action";
import PageLoader from "../../../../../../components/PageLoader";


const ManagementTasks = () => {
	const dispatch = useAppDispatch()
    const itemsData = useSelector(selectListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name', sortable: true, filter: true ,isEdit: true  },
          { field: 'LogisticsProductName', headerName: 'Product Name', sortable: true, filter: true  },
          { field: 'LogisticsVariantName', headerName: 'Variant Name', sortable: true, filter: true  },
      
        ]);
      }
      
	useEffect(() => {
        createColumnDefs()
		dispatch(tasks.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/tasks/list`,entity:'tasks',jsonData:{
          
        }}))
	}, [])

	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
:
		<Table columnData={columnDefs} rowData={itemsData?.result?.items} headingName="Tasks" />
  }
    </>    
     
	);
};

export default ManagementTasks;


